<template>
    <div class="info-header"
        :style="{'background-color':themeColor}"
        :class="collapse?'position-collapse-left':'position-left'">
      <span class="hamburg">
        <el-menu class="el-menu-demo"
            :background-color="themeColor"
            text-color="#fff"
            :active-text-color="themeColor"
            mode="horizontal">
            <el-menu-item
                index="1"
                @click="onCollapse">
                <hamburger :isActive="collapse"></hamburger>
            </el-menu-item>
        </el-menu>
      </span>
      <div class="right-part">
      <div class="invite" @click="handleInvite" v-if="user.recCode">
            推荐码：<div class="code">{{ user.recCode }}</div><div class="operation">复制</div>
      </div>
      <span class="toolbar">
        <el-menu  class="el-menu-demo" :background-color="themeColor" text-color="#fff" :active-text-color="themeColor" mode="horizontal">
          <el-menu-item index="1">
            <theme-picker class="theme-picker" :default="themeColor" @onThemeChange="onThemeChange"></theme-picker>
          </el-menu-item>
          <el-menu-item index="2" v-popover:popover-personal>
            <span class="user-info">
                <span v-text="user.userName"></span>
                <img src="@/assets/user.png"/>
            </span>
            <el-popover ref="popover-personal" placement="bottom-end" trigger="click" :visible-arrow="false">
              <personal-panel :user="user"></personal-panel>
            </el-popover>
          </el-menu-item>
        </el-menu>
      </span>
      </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import Hamburger from '../../Component/Hamburger/Index'
import ThemePicker from '../../Component/ThemePicker/Index'
import PersonalPanel from '../../Component/PersonalPanel/Index'
export default {
    components: {
        PersonalPanel,
        Hamburger,
        ThemePicker
    },
    name: 'TopBar',
    data() {
        return {
            user: JSON.parse(sessionStorage.getItem('user'))
        }
    },
    computed: {
        ...mapState({
            collapse: state => state.app.collapse,
            themeColor: state => state.app.themeColor
        })
    },
    methods: {
    // 折叠导航栏
        onCollapse: function() {
            this.$store.commit('onCollapse')
        },
        onThemeChange: function(themeColor) {
            this.$store.commit('setThemeColor', themeColor)
        },
        async handleInvite() {
            const env = process.env['NODE_ENV']
            const code = this.user.recCode
            let url = ''
            if (env === 'development') {
                url = 'http://127.0.0.1:8000/#/register?invite_code=' + code
            } else {
                url = 'https://www.lpswish.com/#/register?invite_code=' + code
            }

            try {
                await navigator.clipboard.writeText(url)
                this.$message({ message: '复制成功', type: 'success', center: true })
            } catch (err) {
                this.$message({ message: '复制失败', type: 'error', center: true })
            }
        }
    }
}
</script>

<style scoped>
  .info-header{
    height: 60px;
    line-height: 60px;
    border-color: rgba(180, 190, 190, 0.8);
    border-left-width: 1px;
    border-left-style: solid;
    position: fixed;
    top: 0;
    left: 200px;
    right: 0;
    bottom: 0;
    z-index: 1030;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .hamburg{
    float: left;
  }
  /* .toolbar{
    float: right;
  } */
  .position-collapse-left{
    left: 65px;
  }
  .position-left{
    left: 200px;
  }
  .user-info {
    font-size: 16px;
    color: #fff;
    cursor: pointer;
  }
  .user-info img {
    width: 40px;
    height: 40px;
    border-radius: 10px;
    margin: 10px 0px 10px 10px;
  }
  .right-part {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .invite {
    color: #fff;
    display: flex;
    justify-content: space-between;
    align-items: center;

  }
  .code {
    font-size: 16px;
    font-weight: 600;
  }

  .operation {
    margin-left:15px;
    margin-right: 20px;
    cursor: pointer;
    font-size: 12px;
    }
</style>



// WEBPACK FOOTER //
// src/components/Manager/TopBar/Index.vue